import { axiosInstance } from "./AxiosInstance";


const API_URL = "/courses";

export const getCourses = async (limit = 2000, page = 1, search = '') => {
  // Request all 60 records at once by increasing the limit
  try {
    const response = await axiosInstance.get(
      `${API_URL}?limit=${limit}&page=${page}&search=${search}`
    );
    return {
      data: response.data.data,
      pagination: response.data.pagination
    };
  } catch (error) {
    console.error('Error fetching courses', error);
    throw error;
  }
};

export const addCourse = async (courseData) => {
  try {
    const response = await axiosInstance.post(API_URL, courseData);
    return {
      data: response.data.data,
      message: response.data.message
    };
  } catch (error) {
    console.error("Error adding course", error);
    throw error;
  }
};

export const updateCourse = async (courseId, courseData) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/${courseId}`,
      courseData
    );
    return {
      data: response.data.data,
      message: response.data.message
    };
  } catch (error) {
    console.error("Error updating course", error);
    throw error;
  }
};

export const deleteCourse = async (courseId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${courseId}`);
    return {
      data: response.data.data,
      message: response.data.message
    };
  } catch (error) {
    console.error("Error deleting course", error);
    throw error;
  }
};

export const getCourseById = async (courseId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${courseId}`);
    return {
      data: response.data.data,
      message: response.data.message
    };
  } catch (error) {
    console.error("Error fetching course details", error);
    throw error;
  }
};
